import React from 'react';
import PropTypes from 'prop-types';
import AssignedTicketContainer from '../../containers/AssignedTicketContainer';
import EscalatedTicketContainer from '../../containers/EscalatedTicketContainer';
import AllTicketContainer from '../../containers/AllTicketContainer';
import { ConversationBox } from './ConversationComponent.styles';

const ConversationComponent = (props) => {
  function getContainer() {
    const { isAdmin, selectedInboxTab, reviewTicketSelected, validationTicketSelected } = props;
    if (selectedInboxTab.toLowerCase() === 'nominated' || reviewTicketSelected || validationTicketSelected) {
      return <EscalatedTicketContainer {...props} />;
    } else if (isAdmin && selectedInboxTab.toLowerCase() === 'all') {
      return <AllTicketContainer {...props} />;
      // TODO Selected ticket sometimes is empty, this fixes it for now but we need to find out why
    } else if (props.selectedTicket && props.selectedTicket.ticketId) {
      return <AssignedTicketContainer {...props} />;
    }

    return;
  }

  const showSection = props.queueLength > 0 || props.reviewTicketSelected || props.validationTicketSelected;

  return (
    <ConversationBox className={'widget full-height ' + (showSection ? '' : 'hide')}>{getContainer()}</ConversationBox>
  );
};

ConversationComponent.propTypes = {
  general: PropTypes.shape({
    showTools: PropTypes.bool,
  }).isRequired,
  setShowTools: PropTypes.func.isRequired,
};

export default ConversationComponent;
